import { SignalrWindow } from './signalR/inaxSignalR';
import { IINAXCONFIGSERVICE_TOKEN } from './interfaces/IInaxConfigService.interface';
import { InaxConfiguration } from './inaxConfiguration';
import { IEXPANDABLEPANELCOLLECTIONSERVICE_TOKEN } from '../../commonUi/src/expandablePanel/interfaces/IExpandablePanelCollection.interface';
import { ExpandablePanelCollectionService } from './expandablePanelCollectionService/expandablePanelCollection.service';


export const SIGNALR_PROVIDER_ENTRY = { provide: SignalrWindow, useValue: window };
export const INAX_CONFIG_PROVIDER_ENTRY = { provide: IINAXCONFIGSERVICE_TOKEN, useClass: InaxConfiguration, multi: false };
export const EXPANDABLE_PANEL_COLLECTION_ENTRY = { provide: IEXPANDABLEPANELCOLLECTIONSERVICE_TOKEN, useClass: ExpandablePanelCollectionService, multi: false };

export const INAX_COMMON_PROVIDER_ENTRIES = {
    SIGNALR_PROVIDER_ENTRY,
    INAX_CONFIG_PROVIDER_ENTRY,
    EXPANDABLE_PANEL_COLLECTION_ENTRY
}